import { createConnectQueryKey, useQuery } from "@connectrpc/connect-query";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { AuthService } from "@yatayat/gen/yatayat/auth/v1/auth_pb";
import { BookingService } from "@yatayat/gen/yatayat/booking/v1/booking_pb";

import { retryTransient } from "~/lib/rpc/errors";

/** The passenger's session; `data.session` is unset when signed out. */
export function useSession() {
  return useQuery(AuthService.method.getSession, {}, { retry: retryTransient });
}

/**
 * Returns a function to call after signing in or out: it refetches the session and
 * drops cached passenger data, so nothing from the previous passenger stays on screen.
 */
export function useRefreshSession() {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      Promise.all([
        queryClient.resetQueries({
          queryKey: createConnectQueryKey({ schema: BookingService.method.listMyTickets, cardinality: undefined }),
        }),
        queryClient.resetQueries({
          queryKey: createConnectQueryKey({ schema: BookingService.method.getTicket, cardinality: undefined }),
        }),
        queryClient.invalidateQueries({
          queryKey: createConnectQueryKey({ schema: AuthService.method.getSession, cardinality: undefined }),
        }),
      ]),
    [queryClient],
  );
}
